export default __webpack_public_path__ + "static/media/08_pict.da271ef8.svg";